import type { Router, LocationQueryRaw } from 'vue-router';
import NProgress from 'nprogress'; // progress bar

import { useUserStore, useTabBarStore } from '@/store';
import { isLogin } from '@/utils/auth';
import {
  getCurrentUser,
  queryCompanyConfigList,
  queryUserConfigList,
} from '@/api/user';

export default function setupUserLoginInfoGuard(router: Router) {
  router.beforeEach(async (to, from, next) => {
    NProgress.start();
    const userStore = useUserStore();
    const tabbarStore = useTabBarStore();
    if (isLogin()) {
      if (!tabbarStore.paymentMap) {
        const currentUser = await getCurrentUser();
        tabbarStore.setPayment(currentUser);
      }
      // 已经请求了currentUser.ac的接口
      if (Object.keys(userStore.userInfo ?? {}).length !== 0) {
        next();
      } else {
        try {
          const [currentUser, companyConfig, userConfig] = await Promise.all([
            getCurrentUser(),
            queryCompanyConfigList(),
            queryUserConfigList({}),
          ]);
          const { paymentMap } = tabbarStore;
          const routesConfig = router.getRoutes();
          const handleRoute = (routes: any, payMap: any) => {
            const titleMap: any = {
              '/develop': `研发管理${
                payMap.flagShip && payMap.professional ? '（专业版）' : ''
              }`,
              '/develop-pro': `研发管理${
                payMap.flagShip && payMap.professional ? '（旗舰版）' : ''
              }`,
            };
            routes.forEach((route: any) => {
              if (titleMap[route.path]) {
                route.meta.title = titleMap[route.path];
              }
              if (
                (!payMap.flagShip && route.path === '/develop-pro') ||
                (!payMap.professional && route.path === '/develop')
              ) {
                route.meta.hideInMenu = true;
              }
            });
          };
          handleRoute(routesConfig, paymentMap);
          await userStore.setInfo({
            userInfo: currentUser.data?.userInfo,
            permissions: currentUser.data?.permissions,
            companyInfo: currentUser.data?.companyInfo,
            permissionRemarkMap: currentUser.data.permissionRemarkMap,
            sysConfigList: companyConfig.data,
            userConfigList: userConfig.data,
            enablePaymentServiceMap: paymentMap,
          });
          next();
        } catch (error) {
          await userStore.logout();
          next({
            name: 'login',
            query: {
              redirect: to.name,
              ...to.query,
            } as LocationQueryRaw,
          });
        }
      }
    } else {
      if (to.name === 'login') {
        next();
        return;
      }
      next({
        name: 'login',
        query: {
          redirect: to.name,
          ...to.query,
        } as LocationQueryRaw,
      });
    }
  });
  router.afterEach(() => {
    const globalLoadingDom = document.querySelector('#globalLoading');
    if (globalLoadingDom) {
      globalLoadingDom.remove();
    }
    NProgress.done();
  });
}
